import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { loadConfig, AppConfigContext } from './hooks/config';
import type { AppConfig } from './types';
import './styles/global.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root element not found in index.html');

loadConfig()
  .then((config: AppConfig) => {
    createRoot(rootEl).render(
      <StrictMode>
        <AppConfigContext.Provider value={config}>
          <App />
        </AppConfigContext.Provider>
      </StrictMode>
    );
  })
  .catch((err) => {
    console.error('Failed to load runtime config:', err);
    // Render without config — components can handle null via useContext
    createRoot(rootEl).render(
      <StrictMode>
        <App />
      </StrictMode>
    );
  });
